import Alert from 'components/Alert'
import React, { useEffect, useState } from 'react'
import {
  ClientProfileFormAlertContainer,
  ClientProfileFormAvatar,
  ClientProfileFormBalance,
  ClientProfileFormBalanceContainer,
  ClientProfileFormBalanceContent,
  ClientProfileFormBalanceTitle,
  ClientProfileFormDataContainer,
  ClientProfileFormDataFlex,
  ClientProfileFormContainer,
  ClientProfileFormHeaderContainer,
  ClientProfileFormTitle,
  ClientProfileFormUContainer,
  ClientProfileFormUser,
  ClientProfileFormUserContainer,
  ClientProfileFormVerticalDivider,
  ClientProfileFormAddPayment,
  ClientProfileFormAddPaymentButton,
} from './ClientProfileForm.styled'
import avatar from 'assets/images/user.png'
import Tabs from 'components/Tabs/Tabs'
import Appointments from '../Appointments'
import PastPurchase from '../PastPurchase'
import Relationships from '../Relationships'
import ClientSettings from '../ClientSettings'
import { useAppDispatch, useAppState } from 'store'
import { clientActions } from 'store/slices/clients/clients.slice'
import { ClientProfileFormProps } from './ClientProfileForm.props'
import { appointmentActions } from 'store/slices/appointments/appointments.slice'
import { transactionActions } from 'store/slices/transactions/transactions.slice'
import { PENNIES } from 'utils/rate'
import AddPaymentModal from '../Components/AddPaymentModal'

const TAB = [
  'Past Purchases',
  'Appointments',
  'Relationships',
  'Client Settings',
]

const ClientProfileForm = ({
  locationId,
  clientId,
}: ClientProfileFormProps) => {
  const dispatch = useAppDispatch()
  const { currentClient } = useAppState(state => state.clients)
  const { balance } = useAppState(state => state.transaction)

  const [activeTab, setActiveTab] = useState<number>(0)

  const [showAddPaymentModal, setShowAddPaymentModal] = useState<boolean>(false)

  useEffect(() => {
    if (!currentClient && locationId !== '' && clientId !== '') {
      dispatch(
        clientActions.getClientById({
          clientId,
        })
      )
      dispatch(
        transactionActions.getTransactionUserBalance({
          locationId,
          userId: parseInt(clientId),
        })
      )
    }
  }, [locationId, clientId])

  useEffect(() => {
    dispatch(appointmentActions.clearAppointmentPagination())
  }, [activeTab])

  const formatBalance = (amount: number | null) => {
    if (amount) {
      return (amount / PENNIES).toFixed(2)
    }
    return 0
  }
  return (
    <ClientProfileFormContainer>
      {/** Header Title */}
      <ClientProfileFormHeaderContainer>
        <ClientProfileFormTitle>{currentClient?.title}</ClientProfileFormTitle>
        {/* <ClientProfileFormViewProfile to={'/'}>
          view profile
        </ClientProfileFormViewProfile> */}
      </ClientProfileFormHeaderContainer>
      {/** User Info */}
      <ClientProfileFormUserContainer>
        <ClientProfileFormUContainer>
          <ClientProfileFormUser style={{ marginTop: 8 }}>
            {currentClient?.email}
          </ClientProfileFormUser>
          <ClientProfileFormUser style={{ marginTop: 9 }}>
            Member Since 01/2018
          </ClientProfileFormUser>
          <ClientProfileFormAlertContainer>
            <Alert msg={'Waiver NOT signed'} type={'danger'} />
          </ClientProfileFormAlertContainer>
        </ClientProfileFormUContainer>

        <ClientProfileFormDataContainer>
          <ClientProfileFormDataFlex style={{ marginTop: 8 }}>
            <ClientProfileFormUser>Phone:</ClientProfileFormUser>
            <div style={{ marginLeft: 25 }}>
              <ClientProfileFormUser>
                {currentClient?.phone}
              </ClientProfileFormUser>
            </div>
          </ClientProfileFormDataFlex>
          <ClientProfileFormDataFlex>
            <ClientProfileFormUser>Address:</ClientProfileFormUser>
            <div style={{ marginLeft: 25 }}>
              <ClientProfileFormUser>
                {currentClient?.address}
              </ClientProfileFormUser>
            </div>
          </ClientProfileFormDataFlex>
        </ClientProfileFormDataContainer>

        <ClientProfileFormAvatar src={avatar} />
      </ClientProfileFormUserContainer>
      {/** User Balance */}
      <ClientProfileFormBalanceContainer>
        <ClientProfileFormBalanceContent>
          <ClientProfileFormBalanceTitle>
            Balance:
          </ClientProfileFormBalanceTitle>
          <ClientProfileFormBalance>
            $ {formatBalance(balance)}
          </ClientProfileFormBalance>
        </ClientProfileFormBalanceContent>

        <ClientProfileFormVerticalDivider />

        {/* 
          <ClientProfileFormBalanceContent>
            <ClientProfileFormBalanceTitle>Credit:</ClientProfileFormBalanceTitle>
            <ClientProfileFormBalance>$ 125</ClientProfileFormBalance>
          </ClientProfileFormBalanceContent> 
          <ClientProfileFormVerticalDivider />
          */}

        <ClientProfileFormAddPayment>
          <ClientProfileFormAddPaymentButton
            text="Pay for transactions"
            variant="primary"
            preset="filled"
            size={'small'}
            onClick={() => setShowAddPaymentModal(true)}
          />
          {showAddPaymentModal && (
            <AddPaymentModal
              clientId={parseInt(clientId)}
              locationId={locationId}
              onClose={() => setShowAddPaymentModal(!showAddPaymentModal)}
            />
          )}
        </ClientProfileFormAddPayment>

        <ClientProfileFormVerticalDivider />

        <ClientProfileFormBalanceContent>
          <ClientProfileFormBalanceTitle>Notes:</ClientProfileFormBalanceTitle>
        </ClientProfileFormBalanceContent>
      </ClientProfileFormBalanceContainer>
      <div style={{ marginTop: 42 }}>
        <Tabs types={TAB} onPressed={setActiveTab} />
        <div style={{ minHeight: 500, marginBottom: 25 }}>
          {activeTab === 0 && <PastPurchase />}
          {activeTab === 1 && (
            <Appointments
              locationId={locationId}
              clientId={parseInt(clientId)}
            />
          )}
          {activeTab === 2 && (
            <Relationships
              locationId={locationId}
              clientId={parseInt(clientId)}
            />
          )}
          {activeTab === 3 && <ClientSettings />}
        </div>
      </div>
    </ClientProfileFormContainer>
  )
}
export default ClientProfileForm
